import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { LoginService } from 'src/app/services/login/login.service';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { ProgressingComponent } from '../progressing/progressing.component';
import { SocialAuthService } from 'src/app/services/authentication/social-auth.service';
import { NavParams } from '@ionic/angular';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
@Component({
  selector: 'app-social-player-toc',
  templateUrl: './social-player-toc.component.html',
  styleUrls: ['./social-player-toc.component.scss'],
})
export class SocialPlayerTocComponent implements OnInit,OnDestroy {

  generatedCSRF;
  storeServerCSRFToken;
  public featureTermsAndConditionURL: string;
  public featurePrivacyURL: string;
  disableGuestBtn: boolean = false;
  isPlayerLoggedInAsGuest: boolean = false;
  @ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;
  context: any;

  public error: GlobalErrorHandlerService = null;

  constructor(
    private navigator: Navigator,
    private authenticationService: AuthenticationService,
    private loginService: LoginService,
    private galleryService: GalleryService,
    private userSessionService: UserSessionService,
    private eventService: EventsService,
    private appLinks: AppLinksService,
    private config: ConfigService,
    private eventsService: EventsService,
    private appStorageService: AppstorageTsService,
    private socialAuthService: SocialAuthService,
    public navParams: NavParams

  ) { }

  ngOnInit() {
    this.featureTermsAndConditionURL = this.config.getConfig().FEATURE_SITE_TERMS_LINK;
    this.featurePrivacyURL = this.config.getConfig().FEATURE_SITE_PRIVACY_LINK;

    this.context = this.navParams.get("data");
    this.appStorageService.getPlayerAsGuest().then((isGuest) => {
      console.log(isGuest)
      if (isGuest.value === 'true') return this.isPlayerLoggedInAsGuest = true;
      return this.isPlayerLoggedInAsGuest = false;

    })
    this.eventsService.subscribe("events:social:auth:error", (data) => {
			this.error = data;
			if(data.error_code === "CUSTOMER_EXCLUDED_BY_AUTHORITY"){
				this.error.setErrorMessage("Unfortunately, there is an error - you can’t play on this site.")
			}
		});
  }

  generateCSRFToken() {
    return new Promise((resolve, reject) => {
      this.authenticationService.getCsrfToken().subscribe(
        (response) => {
          if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
            this.generatedCSRF = response.payload.token;
            resolve(this.generatedCSRF);
          }
        }
      )
    })
  }

  protected goToLink(url: string): any {
    return this.appLinks.openExternalPage(url);
  }

  doSocialLogin() {
		this.error = null;
    switch (this.context) {
      case 'apple':
        this.socialAuthService.appleLogin(this.isPlayerLoggedInAsGuest);
        break;
      case 'fb':
        this.socialAuthService.fbLogin(this.isPlayerLoggedInAsGuest);
        break;
      case 'google':
        this.socialAuthService.googleLogin(this.isPlayerLoggedInAsGuest);
        break;
      default:
        this.navigator.dismissAll();
        break;
    }

  }

  closeTOC() {
    this.navigator.dismiss();
  }
  ngOnDestroy(){
    this.error = null;
  }

}
